import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserCertification } from '../model/certification';
import { getUserCertifications } from '../api/certifications';

interface CertificationState {
  currentUserCertifications: UserCertification[] | null
}

const initialState: CertificationState = {
  currentUserCertifications: null
};

const certificationSlice = createSlice({
  name: 'certification',
  initialState,
  reducers: {
    setCurrentUserCertifications: (state, action: PayloadAction<UserCertification[]>) => {
      state.currentUserCertifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCertificationsAsync.fulfilled, (state: CertificationState, action: PayloadAction<UserCertification[]>) => {
        state.currentUserCertifications = action.payload;
      })
      .addCase(getUserCertificationsAsync.rejected, (state: CertificationState, action) => {
        console.error(action.error.message);
      })
  },
});

export const getUserCertificationsAsync = createAsyncThunk('program/getUserCertificationsAsync', async ({ programId, accessToken }: { programId: string; accessToken: string}) => {
    const response = await getUserCertifications(accessToken, programId);
    return response;
  }
);


export const { setCurrentUserCertifications } = certificationSlice.actions;
export default certificationSlice.reducer;